import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { Nav, NavItem } from 'react-bootstrap';
import { Stepper, Step, StepLabel } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faFlagCheckered, faExclamation } from '@fortawesome/free-solid-svg-icons';
import {
    applicationSelector,
    chapterSelector,
    recruitmentSelector,
    userSelector,
    questionSelector,
    interestSelector, rankSelector, chapterMemberSelector, authSelector
} from '../redux/selectors';
import { openChapters, toArray } from '../common/util';
import {
    applyStepOne,
    redoStepOne,
    applyStepTwo,
    redoStepTwo,
    fetchApplication,
    fetchUserApplications,
    fetchApplicationInterests,
    fetchMembershipHistory
} from '../redux/actions';
import StepOneForm from './StepOneForm';
import StepTwoForm from './StepTwoForm';
import StepInfo from './StepInfo';
import ApplicationDetail from './ApplicationDetail';
import { union } from 'lodash';

class ApplicationManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chapter: openChapters(this.props.chapters).filter(chapter => chapter.game.title !== "Addiction").shift().id,
            blockedChapters: [],
            application: { id: null, }
        };

        this.getStep = this.getStep.bind(this);
        this.getFlag = this.getFlag.bind(this);
        this.setChapter =  this.setChapter.bind(this);
        this.setBlockedChapter =  this.setBlockedChapter.bind(this);
        this.stepOneSubmit = this.stepOneSubmit.bind(this);
        this.stepTwoSubmit = this.stepTwoSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // Set selected chapter once single application returns
        if (nextProps.applications[this.props.match.params.id]) {
            this.setChapter(nextProps.applications[this.props.match.params.id].chapter);
        }

        if (!this.props.match.params.id  && nextProps.applications !== this.props.applications || !this.props.match.params.id && nextProps.chapterMembers !== this.props.chapterMembers) {
            // Return an array of chapter id's that the user has applied for that arent closed, accepted, or rejected
            const appIds = toArray(nextProps.applications)
                .filter(application => application.user === this.props.auth.currentUser.id)
                .filter(application => application.state !== "accepted" && application.state !== "rejected" && application.state !== "closed")
                .map((application) => { return application.chapter});
            const memberIds = toArray(nextProps.chapterMembers.data)
                .filter(member => member.member === this.props.auth.currentUser.id)
                .map((member) => { return member.chapter});
            const blockedIds = union(appIds, memberIds);
            // Set blocked chapters to disable links
            this.setBlockedChapter(blockedIds);
            // Filter out an Addiction chapter, and any chapters the user has applied for
            let availableChapters = openChapters(this.props.chapters).filter(chapter => chapter.game.title !== "Addiction").filter(chapter => !blockedIds.includes(chapter.id));
            //Set chapter if any are left, otherwise flip to negative and dont render the regular page
            if (availableChapters.length > 0) {
                this.setChapter(availableChapters.sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime())).shift().id);
            } else { this.setChapter(-1) }
        }
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            this.props.getApplication(this.props.match.params.id);
            document.title = "Addiction | Application #"+this.props.match.params.id;
        } else {
            this.props.getUserApplications(this.props.auth.currentUser.slug);
            this.setChapter(openChapters(this.props.chapters).filter(chapter => chapter.game.title !== "Addiction").shift().id);
            document.title = "Addiction | Apply";
        }
        this.props.getApplicationInterests();
        this.props.getMembership();
    }

    setChapter(chapter=0) {
        if (this.state.chapter !== chapter) {
            this.setState({chapter: chapter});
        }
    }

    setBlockedChapter(array) {
        this.setState({ blockedChapters: array })
    }

    stepOneSubmit(values) {
        let gameDetailedHistory = '';
        for (let game of values.gameHistory) {
            gameDetailedHistory += game.title + " for " + parseFloat(game.duration) + " years for " + game.average + " hours per week as a " + game.role + ',';
        }
        let playerType = values.playerTypeOne + "," + values.playerTypeTwo + "," + values.playerTypeThree;
        let birthArray = values.birthdate.split('/');
        let submission = {
            ...values,
            birthdate: new Date(birthArray[0], birthArray[1]-1, birthArray[2]).toISOString(),
            gameDetailedHistory: gameDetailedHistory,
            playerType: playerType,
            chapter: this.state.chapter,
        };
        if (!this.props.match.params.id) {
            this.props.applyStepOne(submission);
        } else if (this.props.applications[this.props.match.params.id].state === "step_1_redo") {
            this.props.redoStepOne(submission, this.props.match.params.id);
        }
    }

    stepTwoSubmit(values) {
        let submission = [];
        Object.keys(values).forEach(key => {
            let question = key.split('|')[1];
            let object = {
                "answer": values[key],
                "question": question,
            };
            submission.push(object);
        });
        console.log(submission);
        if (this.props.applications[this.props.match.params.id].state === "step_1_approved" || this.props.applications[this.props.match.params.id].state === "step_1_redo_approved") {
            this.props.applyStepTwo(submission, this.props.match.params.id)
        }
        else if (this.props.applications[this.props.match.params.id].state === "step_2_redo") {
            this.props.redoStepTwo(submission, this.props.match.params.id)
        }
    }

    getStep(app) {
        if (app) {
            switch (app.state) {
                case "step_1_redo":
                    return 0.1;
                case "step_1_submitted":
                case "step_1_redo_submitted":
                    return 1;
                case "step_1_approved":
                case "step_1_redo_approved":
                case "step_2_redo":
                    return 2;
                case "step_2_submitted":
                case "step_2_redo_submitted":
                    return 3;
                case "step_3_interview":
                    return 4;
                case "accepted":
                    return 5;
                case "rejected":
                    if (app.answers.length > 0) {
                        return 3.2;
                    } else {
                        return 1.2;
                    }
                default:
                    return 0;
            }
        }
    }

    getFlag(app, flag=1) {
        if (app) {
            if (flag === 1) {
                switch (app.state) {
                    case "step_1_submitted":
                    case "step_1_redo_submitted":
                        return (<FontAwesomeIcon className="text-primary" icon={faFlag} size="lg" fixedWidth/>);
                    case 1.1:
                    case "step_1_approved":
                    case "step_1_redo_approved":
                    case "step_2_redo":
                    case "step_2_submitted":
                    case "step_2_redo_submitted":
                    case "step_3_interview":
                    case "accepted":
                        return (
                            <FontAwesomeIcon className="text-primary" icon={faFlagCheckered} size="lg" fixedWidth/>);
                    case "rejected":
                        if (app.answers.length > 0) {
                            return (<FontAwesomeIcon className="text-primary" icon={faFlagCheckered} size="lg"
                                                     fixedWidth/>);
                        }
                        else {
                            return (<FontAwesomeIcon className="text-danger" icon={faFlag} size="lg" fixedWidth/>);
                        }
                    default:
                        return (<FontAwesomeIcon icon={faFlag} size="lg" fixedWidth/>)
                }
            } else {
                switch (app.state) {
                    case "step_2_submitted":
                    case "step_2_redo_submitted":
                        return (<FontAwesomeIcon className="text-primary" icon={faFlag} size="lg" fixedWidth/>);
                    case "step_3_interview":
                    case "accepted":
                        return (
                            <FontAwesomeIcon className="text-primary" icon={faFlagCheckered} size="lg" fixedWidth/>);
                    case "rejected":
                        if (app.answers.length > 0) {
                            return (<FontAwesomeIcon className="text-danger" icon={faFlag} size="lg" fixedWidth/>);
                        }
                        else {
                            return null
                        }
                    case "step_2_redo":
                        return (<FontAwesomeIcon className="text-warning" icon={faFlag} size="lg" fixedWidth/>);
                    default:
                        return (<FontAwesomeIcon icon={faFlag} size="lg" fixedWidth/>)
                }
            }
        } else {
            return (<FontAwesomeIcon icon={faFlag} size="lg" fixedWidth/>)
        }
    }


    // addictguild.com/apply -- pills at top to select game
    // addictguild.com/apply/:appid - pulls current application from database and displays status, possibly forms
    // chapter is set on submit, all new applications are created through /apply
    // /apply should check /users/applications api to see if you have open applications for certain chapters and block
    // submit should redirect to /apply/:appid on success
    // recruitment view should handle acceptance with a series of checkbox options for chapter assignment etc - possibly in api instead?
    render() {
        let formTwoDisplay = () => {
            if (this.props.applications[this.props.match.params.id]) {
                if (this.props.applications[this.props.match.params.id].state === "step_1_approved" || this.props.applications[this.props.match.params.id].state === "step_1_redo_approved" || this.props.applications[this.props.match.params.id].state === "step_2_redo") {
                    return true;
                }
            }
            return false;
        };

        let initialValues = {};
        if (this.props.applications[this.props.match.params.id]) {
            let gameHistory = [];
            this.props.applications[this.props.match.params.id].gameDetailedHistory.slice(0, -1).split(',').map((game) => {
                let exploded = game.split(' for ');
                if (exploded.length > 1) {
                    gameHistory.push( {
                        title: exploded[0],
                        duration: exploded[1].split(' ')[0],
                        average: exploded[2].split(' ')[0],
                        role: exploded[2].split(' hours per week as a ')[1],
                    });
                }
                return true
            });
            initialValues = {
                birthdate: new Date(this.props.applications[this.props.match.params.id].birthdate).getUTCFullYear()+'/'+('0' + (new Date(this.props.applications[this.props.match.params.id].birthdate).getUTCMonth()+1)).slice(-2)+'/'+new Date(this.props.applications[this.props.match.params.id].birthdate).getUTCDate(),
                characterClass: this.props.applications[this.props.match.params.id].characterClass,
                characterLevel: this.props.applications[this.props.match.params.id].characterLevel,
                characterName: this.props.applications[this.props.match.params.id].characterName,
                gameHistory: gameHistory,
                gender: this.props.applications[this.props.match.params.id].gender,
                location: this.props.applications[this.props.match.params.id].location,
                discord: this.props.applications[this.props.match.params.id].discord,
                name: this.props.applications[this.props.match.params.id].name,
                playerTypeOne: this.props.applications[this.props.match.params.id].playerType.split(',')[0],
                playerTypeTwo: this.props.applications[this.props.match.params.id].playerType.split(',')[1],
                playerTypeThree: this.props.applications[this.props.match.params.id].playerType.split(',')[2],
                playtime: this.props.applications[this.props.match.params.id].playtime,
                technicalSkills: this.props.applications[this.props.match.params.id].technicalSkills,
                whyJoin: this.props.applications[this.props.match.params.id].whyJoin,
                microphone: true,
                pc: true,
            }
        } else {
            initialValues = {
                gameHistory: [{role: 'Member'}]
            }
        }
        if (this.state.chapter === -1) {
            return (
                <div>
                    <h1>Error</h1>
                    <div className="panel-adt">
                        You have already applied for all active Addiction Chapters.
                    </div>
                </div>
            )
        }
        if (this.props.auth.loggedIn) {
            return (
                <div className="panel">
                    <h1>Application for {this.props.chapters[this.state.chapter].game.title}</h1>
                    { (!this.props.match.params.id) ? (
                    <Nav bsStyle="pills" activeKey={this.state.chapter}>
                        {
                            openChapters(this.props.chapters)
                                .filter(chapter => chapter.game.title !== "Addiction")
                                .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                .map((chapter, i) => (
                                <NavItem key={`${i}-roster`} eventKey={chapter.id} disabled={this.state.blockedChapters.includes(chapter.id)} onClick={() => this.setChapter(chapter.id)}><h3>{chapter.game.title}</h3></NavItem>
                            ))
                        }
                    </Nav>
                    ) : ('')}

                    <div className="panel-adt">
                        <Stepper activeStep={this.getStep(this.props.applications[this.props.match.params.id])} alternativeLabel>
                            <Step key={1}>
                                <StepLabel>Basic Information</StepLabel>
                            </Step>
                            <Step key={2}>
                                <StepLabel icon={this.getFlag(this.props.applications[this.props.match.params.id], 1)}>
                                    Officer Review
                                </StepLabel>
                            </Step>
                            <Step key={3}>
                                <StepLabel>Extended Information</StepLabel>
                            </Step>
                            <Step key={4}>
                                <StepLabel icon={this.getFlag(this.props.applications[this.props.match.params.id], 2)}>
                                    Officer Review
                                </StepLabel>
                            </Step>
                            <Step key={5}>
                                <StepLabel>
                                    Interview
                                </StepLabel>
                            </Step>
                        </Stepper>
                    </div>
                    <StepInfo application={this.props.applications[this.props.match.params.id]} users={this.props.users} ranks={this.props.ranks} />

                    {/* Check for verified email and display all application stuff otherwise disappoint the user*/}
                    {(this.props.auth.currentUser.emailVerified) ? (<div>

                        {
                        /* if there are url parameters its not a new application */
                        (!this.props.match.params.id  && this.props.interests) ? (
                            <StepOneForm onSubmit={this.stepOneSubmit} chapter={this.props.chapters[this.state.chapter]} errors={this.props.errors} initialValues={initialValues} interests={this.props.interests} />
                        )
                        :
                        /* if there is application data display it*/
                        toArray(this.props.applications)
                            .filter(application => application.id === Number(this.props.match.params.id))
                            .map((application) => (
                            <div key={application.id}>
                            {
                            (this.props.applications[this.props.match.params.id].state === "step_1_redo") ? (
                            <StepOneForm onSubmit={this.stepOneSubmit} chapter={this.props.chapters[this.state.chapter]} errors={this.props.errors} initialValues={initialValues} interests={this.props.interests} />
                            ) : ('')
                            }
                            {
                            /* if we're on step 2 display the form */
                            (formTwoDisplay()) ? (
                            <StepTwoForm onSubmit={this.stepTwoSubmit}
                                questions={
                                    toArray(this.props.questions)
                                        .filter(question => question.chapter === application.chapter)
                                        .sort((a, b) => (a.order - b.order))
                                    }
                                 errors={this.props.errors}
                            />
                            ) : ('')}
                            <ApplicationDetail application={application} auth={this.props.auth} />
                            </div>
                        ))}

                    </div>
                    ) : (
                        <div className="panel-adt">
                            <FontAwesomeIcon className="text-danger" icon={faExclamation} fixedWidth />
                            <span className="text-danger">Your email address is not yet verified.  You will need to do so before beginning an application.</span>
                        </div>
                    )}
                </div>
            )
        } else {
            // can probably change this to a unique page that people we link /apply to will land on, OR do the dashboard shit
            return <Redirect to="/register" />
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    users: userSelector(state),
    ranks: rankSelector(state),
    chapters: chapterSelector(state),
    chapterMembers: chapterMemberSelector(state),
    recruitment: recruitmentSelector(state),
    applications: applicationSelector(state),
    questions: questionSelector(state),
    interests: interestSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    applyStepOne: (application) => dispatch(applyStepOne(application)),
    redoStepOne: (application, appId) => dispatch(redoStepOne(application, appId)),
    applyStepTwo: (application, appId) => dispatch(applyStepTwo(application, appId)),
    redoStepTwo: (application, appId) => dispatch(redoStepTwo(application, appId)),
    getApplication: (application) => dispatch(fetchApplication(application)),
    getUserApplications: (user) => dispatch(fetchUserApplications(user)),
    getApplicationInterests: () => dispatch(fetchApplicationInterests()),
    getMembership: () => dispatch(fetchMembershipHistory()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ApplicationManager));


// WEBPACK FOOTER //
// ./src/Applications/ApplicationManager.js